import React from 'react';
import { useSettings } from '@wix/tpa-settings/react';
import { PolicySectionViewModel } from '../../../../service-page-view-model/policy-section-view-model/policySectionViewModel';
import { SectionTypes } from '../../types';
import settingsParams from '../../settingsParams';
import Section from '../Section';
import SectionTitle from '../SectionTitle/SectionTitle';
import SectionText from '../SectionText/SectionText';
import { useTranslation, useExperiments } from '@wix/yoshi-flow-editor';

export type PolicyProps = {
  viewModel: PolicySectionViewModel;
  className?: string;
};

const PolicyComponent = ({ viewModel, className }: PolicyProps) => {
  const { t } = useTranslation();
  const settings = useSettings();
  const { experiments } = useExperiments();
  const showDefaultValue = experiments.enabled(
    'specs.bookings.showDefaultValue',
  );
  const policySectionTitle = () => (
    <SectionTitle
      title={
        showDefaultValue
          ? settings.get(settingsParams.policySectionTitle) ||
            settings.getDefaultValue(settingsParams.policySectionTitle)
          : settings.get(settingsParams.policySectionTitle)
      }
      dataHook="policy-title"
      className={className}
    />
  );

  const hasCancellationPolicy = !!viewModel.cancellationPolicy;

  const cancellationPolicy = () => (
    <SectionText
      text={viewModel?.cancellationPolicy}
      dataHook="cancellation-policy"
      className={className}
    />
  );

  return hasCancellationPolicy ? (
    <Section sectionType={SectionTypes.POLICY} data-hook="policy-section">
      <div>
        {policySectionTitle()}
        {cancellationPolicy()}
      </div>
    </Section>
  ) : null;
};

export default PolicyComponent;
